(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const mbfLocalUrl = (path) => {
    if (!path) return '/';
    if (/^https?:\/\//i.test(path)) return path;
    const cleanPath = '/' + String(path).replace(/^\/+/, '');
    const lang = String(document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
    const prefix = ['en','de','fr','fa','ar'].includes(lang) ? '/' + lang : '';
    if (prefix && (cleanPath === prefix || cleanPath.startsWith(prefix + '/'))) return cleanPath;
    return prefix + cleanPath;
  };
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'nl';
    try { return new Intl.NumberFormat(locale,{style:'currency',currency}).format((Number(cents)||0)/100); }
    catch (_) { return '€' + ((Number(cents)||0)/100).toFixed(2); }
  };

  const shipping = document.querySelector('[data-mbf-free-shipping]');
  let shippingBusy = false;
  const refreshShipping = async () => {
    if (!shipping || shippingBusy) return;
    shippingBusy = true;
    try {
      const response = await fetch(root + 'cart.js',{headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      const threshold = Number(shipping.dataset.thresholdCents || 12000);
      const subtotal = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
      const remaining = Math.max(0,threshold-subtotal);
      const pct = Math.max(0,Math.min(100,(subtotal/threshold)*100));
      const fill = shipping.querySelector('[data-mbf-free-shipping-fill]');
      const message = shipping.querySelector('[data-mbf-free-shipping-message]');
      if (fill) fill.style.width = pct + '%';
      if (remaining <= 0) {
        shipping.classList.add('is-unlocked');
        if (message) message.textContent = shipping.dataset.unlocked || '';
      } else {
        shipping.classList.remove('is-unlocked');
        const template = shipping.dataset.remainingTemplate || '__AMOUNT__';
        if (message) message.textContent = template.replace('__AMOUNT__',money(remaining));
      }
    } catch (_) {}
    finally { shippingBusy = false; }
  };
  if (shipping) {
    refreshShipping();
    const subtotalNode = document.querySelector('[data-mbf-cart-subtotal]');
    if (subtotalNode) new MutationObserver(() => refreshShipping()).observe(subtotalNode,{subtree:true,childList:true,characterData:true});
    document.addEventListener('click',(event) => {
      if (event.target.closest('[data-mbf-cart-open],[data-mbf-product-add],[data-mbf-sticky-add],[data-mbf-qty-minus],[data-mbf-qty-plus]')) {
        window.setTimeout(refreshShipping,250);
      }
    },true);
  }

  document.querySelectorAll('[data-mbf-quiz]').forEach((quiz) => {
    const goalStep = quiz.querySelector('[data-mbf-quiz-step="goal"]');
    const supportStep = quiz.querySelector('[data-mbf-quiz-step="support"]');
    const result = quiz.querySelector('[data-mbf-quiz-result]');
    const resultCopy = quiz.querySelector('[data-mbf-quiz-result-copy]');
    const resultLink = quiz.querySelector('[data-mbf-quiz-result-link]');
    const matches = quiz.querySelector('[data-mbf-quiz-matches]');
    const matchBest = quiz.querySelector('[data-mbf-quiz-match="best"]');
    const matchStrong = quiz.querySelector('[data-mbf-quiz-match="strong"]');
    const matchOptional = quiz.querySelector('[data-mbf-quiz-match="optional"]');
    const ai = quiz.querySelector('[data-mbf-quiz-ai]');
    const matchCards = {
      best: quiz.querySelector('[data-mbf-quiz-match-card="best"]'),
      strong: quiz.querySelector('[data-mbf-quiz-match-card="strong"]'),
      optional: quiz.querySelector('[data-mbf-quiz-match-card="optional"]')
    };
    const matchTargets = {
      muscle: {
        best: quiz.dataset.matchMuscleBest,
        strong: quiz.dataset.matchMuscleStrong,
        optional: quiz.dataset.matchMuscleOptional
      },
      'fat-loss': {
        best: quiz.dataset.matchFatLossBest,
        strong: quiz.dataset.matchFatLossStrong,
        optional: quiz.dataset.matchFatLossOptional
      },
      energy: {
        best: quiz.dataset.matchEnergyBest,
        strong: quiz.dataset.matchEnergyStrong,
        optional: quiz.dataset.matchEnergyOptional
      },
      recovery: {
        best: quiz.dataset.matchRecoveryBest,
        strong: quiz.dataset.matchRecoveryStrong,
        optional: quiz.dataset.matchRecoveryOptional
      },
      health: {
        best: quiz.dataset.matchHealthBest,
        strong: quiz.dataset.matchHealthStrong,
        optional: quiz.dataset.matchHealthOptional
      },
      joints: {
        best: quiz.dataset.matchJointsBest,
        strong: quiz.dataset.matchJointsStrong,
        optional: quiz.dataset.matchJointsOptional
      },
      'hydration-accessories': {
        best: quiz.dataset.matchHydrationAccessoriesBest,
        strong: quiz.dataset.matchHydrationAccessoriesStrong
      }
    };
    let goal = '';

    const camel = (value) => value.replace(/-([a-z])/g,(_,c)=>c.toUpperCase());
    const cap = (value) => {
      const c = camel(value || '');
      return c ? c.charAt(0).toUpperCase() + c.slice(1) : '';
    };
    const data = (prefix,value) => quiz.dataset[prefix + cap(value)] || '';

    const reset = () => {
      goal = '';
      if (goalStep) goalStep.hidden = false;
      if (supportStep) supportStep.hidden = true;
      if (result) result.hidden = true;
      if (matches) matches.hidden = true;
      document.body.classList.remove('mbf-smart-match-active');
    };

    quiz.querySelectorAll('[data-mbf-quiz-goal]').forEach((button) => button.addEventListener('click',() => {
      goal = button.dataset.mbfQuizGoal || '';
      if (goalStep) goalStep.hidden = true;
      if (supportStep) supportStep.hidden = false;
      supportStep?.querySelector('button')?.focus();
    }));

    quiz.querySelectorAll('[data-mbf-quiz-support]').forEach((button) => button.addEventListener('click',() => {
      const support = button.dataset.mbfQuizSupport || 'supplements';
      let copy = data('result',goal);
      let url = data('url',goal);

      if (support === 'training-plan') {
        copy = quiz.dataset.resultTrainingPlan || copy;
        url = quiz.dataset.urlTrainingPlan || url;
      } else if (support === 'personal-training') {
        copy = quiz.dataset.resultPersonalTraining || copy;
        url = quiz.dataset.urlPersonalTraining || url;
      } else if (support === 'nutrition') {
        copy = quiz.dataset.resultNutrition || copy;
        url = quiz.dataset.urlNutrition || url;
      } else if (support === 'accessories') {
        copy = quiz.dataset.resultAccessories || copy;
        url = quiz.dataset.urlAccessories || url;
      }

      if (resultCopy) resultCopy.textContent = copy;

      const showMatches = support === 'supplements' || support === 'accessories';
      const matchGoal = support === 'accessories' ? 'hydration-accessories' : goal;
      if (matches) matches.hidden = !showMatches;
      if (resultLink) {
        resultLink.hidden = true;
        resultLink.removeAttribute('href');
        if (!showMatches && url) {
          resultLink.href = mbfLocalUrl(url);
          resultLink.hidden = false;
        }
      }

      if (showMatches) {
        if (matchBest) matchBest.textContent = data('best',matchGoal);
        if (matchStrong) matchStrong.textContent = data('strong',matchGoal);
        if (matchOptional) matchOptional.textContent = data('optional',matchGoal);

        const targets = matchTargets[matchGoal] || {};
        Object.entries(matchCards).forEach(([tier, card]) => {
          if (!card) return;
          const target = targets[tier];
          if (target && /^\/(products|collections|pages)\//.test(target)) {
            card.hidden = false;
            card.href = mbfLocalUrl(target);
          } else {
            card.hidden = true;
            card.removeAttribute('href');
          }
        });
      }

      if (ai) {
        ai.dataset.mbfAiContext =
          'MBF Smart Match. Goal: ' + goal +
          '. Desired support: ' + support +
          '. Use live Shopify catalog data and recommend only in-stock items. ' +
          'Keep supplements, services and accessories separate. ' +
          'Never include shakers, bottles, apparel, bags, belts, straps, wraps or other accessories in the main supplement recommendations unless Desired support is accessories. ' +
          'For energy goals, primary recommendations must be relevant pre-workout/performance products; do not recommend a shaker as a main match. ' +
          'Return one best match, at most one strong match and one optional addition only when each has a direct practical relationship to the goal. ' +
          'Do not fill recommendation slots just to increase basket value. Keep claims evidence-based and avoid medical promises.';
      }

      if (supportStep) supportStep.hidden = true;
      if (result) result.hidden = false;
      document.body.classList.add('mbf-smart-match-active');
      result?.focus?.();
    }));

    quiz.querySelector('[data-mbf-quiz-restart]')?.addEventListener('click',reset);
  });

  const localeRoot = window.Shopify?.routes?.root || '/';
  document.querySelectorAll('a[href^="/products/"],a[href^="/collections/"],a[href^="/pages/"],a[href^="/blogs/"],a[href^="/search"]').forEach((link) => {
    if (localeRoot === '/' || link.dataset.mbfLocaleFixed === '1') return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith(localeRoot)) return;
    link.setAttribute('href',localeRoot.replace(/\/$/,'') + href);
    link.dataset.mbfLocaleFixed = '1';
  });
})();